import {
    Table,
    TableHead,
    TableRow,
    TableBody,
} from "@material-ui/core";
import React from "react";
import Row from "./Row/Row";
import HeaderCell from "./HeaderCell/HeaderCell";
import { LynxTableProps } from "./LynxTableProps";
import { lynxTableStyles } from "./LynxTableStyles";
import { LynxPagination } from "./LynxPagination/LynxPagination";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

export function LynxTable<T>({
    rows,
    columns,
    rowKey,
    isLoading = false,

    expandable,
    expandableContent,

    sortedBy,
    sortDirection,
    onSortChange = () => {},

    isLastPage = false,
    page = 0,
    onPageChange = () => {},
}: LynxTableProps<T>) {
    const classes = lynxTableStyles();

    return (
        <>
            {!isLoading && (
                <LynxPagination
                    page={page}
                    isLastPage={isLastPage}
                    onPageChange={onPageChange}
                />
            )}
            <Table className={classes.root}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <HeaderCell
                                key={column.id}
                                {...column}
                                onSortChange={(direction) =>
                                    onSortChange(column.id, direction)
                                }
                                currentSortColumn={sortedBy}
                                currentSortDirection={sortDirection}
                            />
                        ))}
                        {expandable && <HeaderCell />}
                    </TableRow>
                </TableHead>
                <TableBody className={classes.tableBody}>
                    {isLoading && (
                        <div className={classes.indicatorContainer}>
                            <LoadingIndicator className={classes.indicator} />
                        </div>
                    )}
                    {rows.map((row) => (
                        <Row
                            key={row[rowKey]}
                            columns={columns}
                            data={row}
                            expandable={expandable}
                            expandableContent={expandableContent}
                        />
                    ))}
                </TableBody>
            </Table>
            {!isLoading && (
                <LynxPagination
                    page={page}
                    isLastPage={isLastPage}
                    onPageChange={onPageChange}
                />
            )}
        </>
    );
}
